"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyIntValueToString = exports.currencyIntValueToFraction = exports.currencyStringToIntValue = exports.isAmountDetails = void 0;
const currency_js_1 = __importDefault(require("currency.js"));
const CurrencyCodesIso4217_1 = require("./CurrencyCodesIso4217");
__exportStar(require("./CurrencyCodesIso4217"), exports);
// Match a string that begins with one or more digits followed by (optionally) a period and exactly two digits.
// No plus sign or minus sign is allowed at the start of the string.
// No other characters are allowed at the start of the string.
// No other characters are allowed at the end of the string.
const positiveNumberWithTwoOptionalDecimalPlaces = /^[0-9]+(\.[0-9][0-9])?$/;
function isValidCheckoutAmount(totalAmount) {
    return typeof totalAmount === 'string' &&
        positiveNumberWithTwoOptionalDecimalPlaces.test(totalAmount);
}
/**
 * Checks if obj is a valid AmountDetails object
 * WARNING: will return FALSE if totalAmount is negative or zero
 */
function isAmountDetails(obj) {
    if (obj == null || typeof obj !== 'object') {
        return false;
    }
    const amountDetails = obj;
    return (0, CurrencyCodesIso4217_1.isIso4217)(amountDetails.currency) && isValidCheckoutAmount(amountDetails.totalAmount);
}
exports.isAmountDetails = isAmountDetails;
/**
 * Turns a currency string into an int value.
 * This removes some complications of working with strings and fractions
 * "123.45" will become 12345 and "£246.35" will become 24635
 */
function currencyStringToIntValue(totalAmount) {
    return (0, currency_js_1.default)(totalAmount).intValue;
}
exports.currencyStringToIntValue = currencyStringToIntValue;
/**
 * Converts currency stored as an integer back to standard fraction notation.
 * Example: if "£123.45" was stored as 12345, calling currencyIntValueToFraction(12345) will return 123.45
 */
function currencyIntValueToFraction(intValue) {
    return (0, currency_js_1.default)(intValue, { fromCents: true }).value;
}
exports.currencyIntValueToFraction = currencyIntValueToFraction;
/**
 * Converts currency stored as an integer back to standard fraction notation and returns it as a string.
 * Example: if "£123.45" was stored as 12345, calling currencyIntValueToString(12345) will return "123.45"
 */
function currencyIntValueToString(intValue) {
    return (0, currency_js_1.default)(intValue, { fromCents: true }).toString();
}
exports.currencyIntValueToString = currencyIntValueToString;
